import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert, FormSelect } from 'react-bootstrap';
import axios from 'axios';

const AllUsersAdminPage = () => {
    const [users, setUsers] = useState([]);
    const [filterUsers, setFilterUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [roles, setRoles] = useState([])

    // Fetch users from API
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axios.get('https://api.biznetusa.com/api/all-users');
                setUsers(response.data.allusers);
                setFilterUsers(response.data.allusers);
            } catch (err) {
                setError('Error fetching user data');
            } finally {
                setLoading(false);
            }
        };
        const fetchRoles = async () => {
            try {
                const response = await axios.get('https://api.biznetusa.com/api/get-roles');
                const data = response.data.roles
                setRoles(data);
                console.log(data)
            } catch (err) {
                console.error("Failed to fetch roles: ", err);
            }

        }

        fetchRoles();
        fetchUsers();
    }, []);

    const handleFilters = (e) => {
        const value = e.target.value;
        if (value === "all") {
            setFilterUsers(users);
        } else {
            setFilterUsers(() => {
                const filter = users.filter((elem) => elem.roles.role_name === value);
                return filter;
            })
        }

    }

    if (loading) {
        return <Spinner animation="border" variant="primary" />;
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
        <div className="container mt-5">
            <h1>All Users</h1>
            <h3 className="mt-3 fs-4">Filter by Role</h3>
            <FormSelect name="filter_by_type" id="filter_by_type" className="mb-3" onChange={handleFilters}>
                <option value="all">All Roles</option>
                {roles.map(role =>
                    <option key={role.id} value={role.role_name}>{role.role_name}</option>
                )}
            </FormSelect>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>User Role</th>
                        <th>Assigned Role</th>
                    </tr>
                </thead>
                <tbody>
                    {filterUsers.length > 0 ? (
                        filterUsers.map((user) => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.user_role || 'No Role Assigned'}</td>
                                <td>
                                    {user.roles
                                        ? user.roles.role_name
                                        : 'No Assigned Role'}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center">
                                No users found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default AllUsersAdminPage;
